import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Board";

/** Registered physical scoreboards and the pairing flow that claims them. */
export const BoardService = {
	endpoint,
	getMine: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Mine`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	/** Latest published board release: { version, url } (nulls when none published). */
	latestRelease: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/LatestRelease`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	claim: async (pairingCode: string, name: string) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Claim`, {body: JSON.stringify({pairingCode, name}), headers: {"Content-Type": "application/json"}, method: "POST"}),
	unpair: async (id: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Unpair/${id}`, {headers: {"Content-Type": "application/json"}, method: "DELETE"}),
	updateSingleById: async (id: number, data: any) => await Service.updateSingleById(endpoint, id, data)
}
